import {defineStore} from "pinia";
import load from "@/common/load";
import devStore from "@/stores/devStore"
import userStore from "@/stores/user"
import tagStore from "@/stores/tagStore"
import {router} from "@/router";
import {axiosGet, axiosPost} from "@/layouts/admin-sidebar/requstDev";
import api from "@/service/api";
import mqttTool from "@/utils/mqtt/index"
import cmd from "@/utils/mqtt/cmd.json"
import {notification} from "ant-design-vue";
import {InfoCircleOutlined} from "@ant-design/icons-vue";
import {h} from "vue";

let time = null;
let timeCount = 0;
let time4G = null;
let time4GCount = 0;
export default defineStore('singleDev', {
    persist: {
        enabled: true, strategies: [{key: 'singleDev', storage: sessionStorage}]
    }, state() {
        /*初始数据列表*/
        return {
            /* 当前选中的设备 */
            currentCode: {
                qrCode: "",
                type: "",
                last: "", // 上一个二维码
                next: "", //下一个二维码
                data: 0, //当前数组对象
                label: 0, //当前标记
                is: false, // 是不是无归属列表
                getDevTagList: [], // 获取设备绑定的标签列表
                netType: "", // 设备联网类型
                info: [], // 设备基本信息 MQTT
                currentImageUrl: "", // 图片地址
                parkFrame: "", // 车位框状态
            },
            identityPark: {},
            reboot: true, //重启状态
            gateWayLock: [], // 网关下的地锁列表
            lockSate: false,
        }
    }, actions: {
        clearTime() {
            clearInterval(time);
            clearInterval(time4G);
            timeCount = 0;
            time4GCount = 0;
        }, /* 更改当前选中的设备信息 */
        /**
         * @Date: 2024-06-28 14:27:26
         * @LastEditors:ahuan
         * @description:code 二维码  data当前数组  state 是否是无列表二维码
         * @return: 返回值
         */
        changeCurrentCode(code, data = [], state = 'list', noRouter = false) {
            if (code === '???') {
                return load.error("当前二维码不规范...")
            }
            this.$state.identityPark = {};
            if (code !== this.$state.constructor.qrCode) {
                let obj = {
                    qrCode: code,
                    type: '',
                    deviceId: '',
                    netType: "",
                    info: [],
                    getDevTagList: [],
                    currentImageUrl: "",
                    parkFrame: ""
                };
                let type = code.substring(0, 2);
                switch (type) {
                    case '21':
                        obj.type = '26';
                        break;
                    case 'C2':
                        obj.type = '25';
                        break;
                    case 'BA':
                        obj.type = '31';
                        break;
                    case 'B8':
                        obj.type = '32';
                        break;
                    case 'AA':
                        obj.type = '33';
                        break;
                    case 'AB':
                        obj.type = '35';
                        break;
                    case 'A7':
                        obj.type = '7';
                        break;
                    case 'A8':
                        obj.type = '8';
                        break;
                    case 'DC':
                        obj.type = '71';
                        break;
                    default:
                        load.error("当前平台不支持这个设备类型...");
                        break;
                }

                if (obj.type) {
                    if (cmd[obj.type] && cmd[obj.type].hasOwnProperty('imageUrl')) {
                        obj.currentImageUrl = cmd[obj.type]['imageUrl'].replace(/-/g, code) + '?' + new Date().getTime();
                    }
                    if (data.length === 0) {
                        data = this.$state.currentCode.data;
                    }
                    let indexs = -1;
                    if (data.length) {
                        indexs = data.findIndex(item => item.uniqueCode === code);
                    }
                    let online = false;
                    if (indexs !== -1) {
                        if (state === 'list') {
                            obj['is'] = false; // 不是无归属列表
                            obj['label'] = data[indexs].label;
                            obj['parkFrame'] = data[indexs].parkFrame;
                            obj['deviceId'] = data[indexs].deviceId;
                        } else if (state === 'nolist') {
                            obj['is'] = true; // 是无归属列表
                            obj['label'] = 0;
                            obj['parkFrame'] = 2;
                            online = true;
                            obj['deviceId'] = data[indexs].deviceId || 0;
                        }
                        obj['last'] = online ? {
                            code: (indexs - 1 < 0) ? '???' : data[indexs - 1].uniqueCode || '0',
                            online: 1
                        } : {
                            code: (indexs - 1 < 0) ? '???' : data[indexs - 1].uniqueCode || '0',
                            online: (indexs - 1 < 0) ? 0 : data[indexs - 1].online
                        };
                        obj['data'] = data;
                        obj['next'] = online ? {
                            code: (indexs + 1 >= data.length) ? '???' : data[indexs + 1].uniqueCode || '0',
                            online: 1
                        } : {
                            code: (indexs + 1 >= data.length) ? '???' : data[indexs + 1].uniqueCode || '0',
                            online: (indexs + 1 >= data.length) ? 0 : data[indexs + 1].online
                        };
                    } else {
                        if (state === 'list') {
                            obj['is'] = false; // 不是无归属列表
                        } else if (state === 'nolist') {
                            obj['is'] = true; // 是无归属列表
                            online = true;
                        }
                        let tag = tagStore();
                        let index = -1;
                        if (Object.keys(tag.currentTagListInfo).length) {
                            index = tag.currentTagListInfo.devices.findIndex(item => item.uniqueCode === code);
                        }
                        if (index !== -1) {
                            obj['last'] = {
                                code: (indexs - 1 < 0) ? '???' : data[indexs - 1].uniqueCode || '0',
                                online: (indexs - 1 < 0) ? 1 : 0
                            }
                            obj['data'] = data;
                            obj['next'] = {
                                code: (indexs + 1 >= data.length) ? '???' : data[indexs + 1].uniqueCode || '0',
                                online: (indexs + 1 >= data.length) ? 1 : 0
                            }
                        } else {
                            obj['last'] = {
                                code: '???',
                                online: 0
                            }
                            obj['data'] = [];
                            obj['next'] = {
                                code: '???',
                                online: 0
                            };
                        }
                    }
                } else {
                    obj['last'] = {
                        code: '???',
                        online: 0
                    }
                    obj['data'] = [];
                    obj['next'] = {
                        code: '???',
                        online: 0
                    };
                }
                if (!noRouter) {
                    router.replace('/dash/devInfo');
                }
                this.$state.currentCode = obj;
                this.getDevTag();
                if (obj.type === '71') {
                    this.getWays();
                }
                // 获取设备联网类型
                this.obtainTheDeviceNetworkingType('getDevType', this.assignInformationFunctions);
            }
        },
        devTagUrl(type) {
            return 'https://www.beefindtech.com/webProject/mapDataEdit/images/' + type + '.png';
        }, /* 更改当前标记 */
        async changeDevLabel(label) {
            let user = userStore();
            let dev = devStore();
            if (this.$state.currentCode.is) {
                return load.error("无归属设备暂未开放此功能...")
            }
            try {
                load.loading("更改设备标记中...");
                let result = await axiosPost(api.changeTheDeviceTag, {
                    userId: user.userId, data: {
                        uniqueCode: this.$state.currentCode.qrCode, label
                    }
                });
                console.log(result)
                if (result.result === '1') {
                    load.success("更改标记成功...");
                    load.loaded();
                    this.$state.currentCode.label = label;
                    for (let i = 0; i < dev.devListInfo.deviceList.length; i++) {
                        for (let j = 0; j < dev.devListInfo.deviceList[i].devices.length; j++) {
                            if (dev.devListInfo.deviceList[i].devices[j].uniqueCode === this.$state.currentCode.qrCode) {
                                dev.devListInfo.deviceList[i].devices[j].label = label
                            }
                        }
                    }
                    dev.getDevStoreList();
                } else {
                    load.error(result.msg);
                }
            } catch (e) {
                load.error("更改设备标记出错...")
            }
        }, /* 获取当前设备标签 */
        async getDevTag() {
            let user = userStore();
            try {
                let result = await axiosPost(api.getDevTagInfo, {
                    userId: user.userId, uniqueCode: this.$state.currentCode.qrCode
                });
                if (result.result === '1') {
                    this.$state.currentCode.getDevTagList = result.data.tags;
                } else {
                    load.error("获取设备标签失败...")
                }
            } catch (e) {
                load.error("获取设备标签报错error...")
            }
        }, /* 解绑当前设备某个标签 */
        handleClose(item, event) {
            let user = userStore();
            event.preventDefault()
            try {
                load.confirm(`是否解绑当前设备${this.$state.currentCode.qrCode}的"${item.tagName}"标签`, async () => {
                    let result = await axiosPost(api.deviceDeletionTags, {
                        userId: user.userId, data: {
                            uniqueCode: this.$state.currentCode.qrCode, tagId: item.tagId
                        }
                    });
                    if (result.result === '1') {
                        load.success("解绑设备标签成功...");
                        this.getDevTag();
                    } else {
                        load.error("解绑设备标签失败...")
                    }

                });
            } catch (e) {
                load.error("解绑设备标签报错error...")
            }
        },
        // 获取设备联网类型
        obtainTheDeviceNetworkingType(msg, f, my = false, myMsg = '') {
            this.clearTime();
            if (cmd[this.$state.currentCode.type] || my) {
                let e = () => {
                    // 传递消息的方法
                    mqttTool.deliverTheMessage = f;
                    console.log(mqttTool.subscribeSuccess, '-------------')
                    if (mqttTool.subscribeSuccess) {
                        mqttTool.doUnSubscribe();
                    }
                    mqttTool.subscription.topic = "/mqttshell-return/" // 默认
                    // 订阅主题
                    mqttTool.doSubscribe();
                    // 发布信息
                    mqttTool.publish.payload = cmd[this.$state.currentCode.type][msg];
                    if (my && myMsg) {
                        mqttTool.publish.payload = myMsg;
                    }
                    mqttTool.doPublish();
                    const key = 'updatable';
                    time = setInterval(() => {
                        if (timeCount >= 15 && this.$state.currentCode.info.length === 0) {
                            clearInterval(time);
                            notification.open({
                                key,
                                message: '提示',
                                description: `当前设备${this.$state.currentCode.qrCode}已掉线...`,
                                icon: () => h(InfoCircleOutlined, {style: 'color: #108ee9'}),
                                style: {
                                    color: "red"
                                },
                                duration: null
                            });
                        }
                        timeCount++;
                        if (this.$state.currentCode.netType || !mqttTool.client.connected) {
                            clearInterval(time);
                        } else {
                            mqttTool.doPublish();
                        }
                    }, 1000)
                }
                if (mqttTool.client.connected) {
                    e();
                } else {
                    // 连接MQTT
                    mqttTool.MqttConnection(e);
                }
            } else {
                load.error("该指令还未完善...")
            }
        }, // 获取4G卡号
        getCard() {
            this.$state.currentCode.info[26] = "获取中"
            let e = () => {
                // 传递消息的方法
                mqttTool.deliverTheMessage = this.assignInformationFunctions;
                if (mqttTool.subscribeSuccess) {
                    mqttTool.doUnSubscribe();
                }
                // 订阅主题
                mqttTool.doSubscribe();
                mqttTool.publish.payload = cmd[this.$state.currentCode.type]['get4GCard'];
                mqttTool.doPublish();
                time4G = setInterval(() => {
                    if (time4GCount >= 15 && this.$state.currentCode.info[26] === '获取中') {
                        this.$state.currentCode.info[26] = '0'
                        load.error("获取4G卡号失败...");
                        clearInterval(time4G);
                        time4GCount = 0;
                    }
                    time4GCount++;
                    if (this.$state.currentCode.info[26] !== '获取中') {
                        clearInterval(time4G);
                        time4GCount = 0;
                    } else {
                        mqttTool.doPublish();
                    }

                }, 3000)
            }
            if (mqttTool.client.connected) {
                e()
            } else {
                mqttTool.MqttConnection(e)
            }

        }, // 分配信息函数
        assignInformationFunctions(topic, msg) {
            // 处理回传的[  跟] 正常获取的数据
            if (msg.indexOf('QCCID') === -1) {
                msg = JSON.parse(msg);
                console.log(msg)
                if (msg[3].trim().length > 0) {
                    this.$state.currentCode.netType = '4G';
                } else if (msg[14].trim().split('addr:').length >= 2 && msg[14].trim().split('addr:')[1].length > 0) {
                    this.$state.currentCode.netType = 'WIFI';
                } else {
                    if (msg[31] === 'static' && this.$state.currentCode.type !== '71') {
                        this.$state.currentCode.netType = 'LAN(no DHCP)';
                    } else {
                        this.$state.currentCode.netType = 'LAN';
                    }
                }
                this.$state.currentCode.info = msg;
            } else {
                // 4g卡号
                this.$state.currentCode.info[26] = msg.split(' ')[2].split('OK')[0].trim();
            }

        },
        async setParkNumber(list) {
            let colorObj = {
                '0': '#000',
                '1': '#F00',
                '2': '#0F0',
                '3': '#FF0',
                '4': '#00F',
                '5': '#F0F',
                '6': '#0FF',
                '15': '#FFF',
                '17': '#000',
            }
            let result = await axiosGet(api.getTheDeviceColor.replace(/-/g, this.$state.currentCode.qrCode) + '?' + new Date().getTime());
            let colorType = result.trim().split('\n')[1].split('=')[1];
            list['红绿灯颜色'] = colorObj[colorType];
            this.$state.identityPark = list;
        },
        rebootDev() {
            load.loading("设备开始重启...");
            // 传递消息的方法
            mqttTool.deliverTheMessage = this.rebootAlert;
            if (mqttTool.subscribeSuccess) {
                mqttTool.doUnSubscribe();
            }
            mqttTool.subscription.topic = '/Beefind/prep/v1/up/camera/dev_init/'
            // 订阅主题
            mqttTool.doSubscribe();
            mqttTool.publish.payload = cmd[this.$state.currentCode.type]['reboot'];
            mqttTool.doPublish();
        },
        rebootAlert(topic, msg) {
            if (msg.indexOf(this.$state.currentCode.qrCode) !== -1) {
                notification.open({
                    key: "reboot",
                    message: '提示',
                    description: `当前设备${this.$state.currentCode.qrCode}已 上线...`,
                    icon: () => h(InfoCircleOutlined, {style: 'color: #108ee9'}),
                    style: {
                        color: "green"
                    },
                    duration: null
                });
                if (mqttTool.subscribeSuccess) {
                    mqttTool.doUnSubscribe();
                }
                mqttTool.subscription.topic = '/mqttshell-return/'
                // 订阅主题
                mqttTool.doSubscribe();
            }
        },
        async getWays() {
            let config = {};
            let locks = [];
            this.$state.gateWayLock = [];
            this.$state.lockSate = true;
            try {
                let result = await axiosGet(api.getGatewayList.replace(/-/g, this.$state.currentCode.qrCode))
                let result2 = await axiosGet(api.getGatewayonLineList.replace(/-/g, this.$state.currentCode.qrCode))
                console.log(result)
                if (result.length > 10) {
                    this.$state.lockSate = false;
                    let lockList = result.trim().split('[cfg]')[1].replace(/=/g, ':').replace(/\n/g, ' ').trim().split(' ');
                    config = {};
                    locks = [];
                    lockList.forEach(item => {
                        const parts = item.split(':');
                        const key = parts[0];
                        const value = parts[1] || ''; // handle case where value is empty
                        config[key] = value;
                    })
                    for (let i = 0; i < 6; i++) {
                        if (config[`lock_code_${i}`] === '') continue;
                        locks.push(config[`lock_code_${i}`])
                    }
                    let dev = devStore();
                    // if (!this.$state.currentCode.is) {
                    let index = 0;
                    for (let i = 0; i < dev.devListInfo.deviceList.length; i++) {
                        for (let j = 0; j < dev.devListInfo.deviceList[i].devices.length; j++) {
                            if (dev.devListInfo.deviceList[i].devices[j].uniqueCode === this.$state.currentCode.qrCode) {
                                index = i;
                                break;
                            }
                        }
                    }
                    let obj = [];
                    for (let i = 0; i < locks.length; i++) {
                        let state = result2 & 1;
                        result2 >>= 1;
                        obj.push({
                            name: locks[i],
                            online: state
                        })
                    }
                    console.log("-------------------201111--------------")
                    console.log(obj)
                    let result3 = await axiosPost(api.getLocksInfo, {
                        "build_id": dev.devListInfo.buildId,
                        "floor_id": dev.devListInfo.deviceList[index].floor_id,
                        "dev_type": "73"
                    })
                    if (result3.result === '1') {
                        let objs = [];
                        result3.data.forEach(v => {
                            obj.forEach(v2 => {
                                if (v.uniqueCode === v2.name) {
                                    v['online'] = v2.online
                                    objs.push(v)
                                }
                            })
                        })
                        obj = objs;
                    } else {
                        load.error("获取地锁列表失败...")
                    }
                    this.$state.gateWayLock = obj;
                }
                // } else {
                //     load.error('获取网关下列表失败...')
                // }
            } catch (e) {
                load.error('获取网关下列表失败...')
            }
        },
        // Mqtt获取网关下地锁信息
        getlocks(e, state = false) {
            // 传递消息的方法
            mqttTool.deliverTheMessage = (topic, message) => {
                console.log(topic)
                let devices = JSON.parse(message).devices;
                if (devices.length !== 0) {
                    load.success(state ? '修改成功!' : "刷新成功!")
                    for (let i = 0; i < this.$state.gateWayLock.length; i++) {
                        for (let j = 0; j < devices.length; j++) {
                            if (this.$state.gateWayLock[i].uniqueCode === devices[j].uniqueCode) {
                                this.$state.gateWayLock[i].ultraThreshold = devices[j].ultraThreshold;
                                this.$state.gateWayLock[i].workMode = devices[j].workMode;
                            }
                        }
                    }
                }
            };
            if (mqttTool.subscribeSuccess) {
                mqttTool.doUnSubscribe();
            }
            mqttTool.subscription.topic = '/Beefind/prep/v1/up/lockgateway/device_state/'
            // 订阅主题
            mqttTool.doSubscribe();
            mqttTool.publish.topic = '/Beefind/prep/v1/down/lockgateway/get_device_state/'
            // 发布信息
            mqttTool.publish.payload = JSON.stringify({
                'devices': [],
            });
            mqttTool.doPublish();
        }
    }
})
